import { SHELL } from "../shell/shell.const";

const AUTH = '';
const AUTH_LOGIN = '';
const AUTH_REGISTER = 'registro';

export const AUTH_ROUTES = {
  AUTH,
  AUTH_LOGIN,
  AUTH_REGISTER,

  ROUTE_AUTH_LOGIN: `${AUTH}/${AUTH_LOGIN}`,
  ROUTE_AUTH_REGISTER: `${AUTH}/${AUTH_REGISTER}`,
}

